module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"fileSelected":"file selezionato","filesSelected":"file selezionati","unselectFiles":"Deseleziona i file","addVimeoVideoTooltip":"Aggiungi Vimeo video","eventOffersTooltip":"Proposte dell\u0027evento","eventOrdersTooltip":"Ordini dell\u0027evento","selectAll":"Seleziona tutti i file","enableFolderView":"Abilita vista cartelle","enableFlatFilesView":"Visualizza tutte le foto"}}')
  delete Component.options._Ctor
}
